import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { hasGlobalFeature } from 'selectors';
import imageSrc from 'images/image_el.svg';
import ImageLibraryPicker from 'components/shared/ImageLibraryPicker';
import DropTarget from './DropTarget';

class Dropzone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pickerVisible: false,
    };
    this.togglePicker = this.togglePicker.bind(this);
  }

  togglePicker() {
    this.setState(state => ({ pickerVisible: !state.pickerVisible }));
  }

  render() {
    const { pickerVisible } = this.state;
    const {
      isOver,
      uploading,
      onUpload,
      connectDropTarget,
      hideImageIcon,
      canUseImageLibrary,
    } = this.props;

    const uploadAreaClassName = classNames('EditorElement-uploadArea', {
      'EditorElement-uploadArea--dropZone': true,
      'is-over': isOver,
    });

    const buttonClassName = classNames(
      'EditorElement-uploadButton',
      'NewButton NewButton--center NewButton--white',
    );

    return connectDropTarget(
      <div className={uploadAreaClassName}>
        {!hideImageIcon && (
          <img
            className="EditorElement-icon"
            src={imageSrc}
            alt={t('image_library.upload')}
          />
        )}
        <p className="EditorElement-description">
          {t('image_library.drag_and_drop_file')} {t('conjunctions.or')}
        </p>
        <div className={`${buttonClassName} mb-8`} disabled={uploading}>
          <span>
            {uploading
              ? t('image_library.uploading')
              : t('image_library.upload')}
          </span>
          <input
            type="file"
            accept="image/*"
            onChange={e => onUpload(e.target.files[0])}
            disabled={uploading}
          />
        </div>
        {canUseImageLibrary && (
          <button
            type="button"
            className={buttonClassName}
            onClick={this.togglePicker}
            disabled={uploading}
          >
            {t('image_library.select_from_library')}
          </button>
        )}
        {canUseImageLibrary && (
          <div className="mt-32 c-gray-dark td-i fs-i">
            {t('image_library.memorable_names_description_note')}
          </div>
        )}
        {pickerVisible && (
          <ImageLibraryPicker
            onSelect={onUpload}
            onDismiss={this.togglePicker}
          />
        )}
      </div>,
    );
  }
}

const mapStateToProps = state => ({
  canUseImageLibrary: hasGlobalFeature(state, 'can_use_image_library'),
});

export default connect(mapStateToProps)(DropTarget(Dropzone));
